import React from 'react';
import { Stack, Box, Button } from '@mui/material';
import { EmptyConfigurationMessage } from './EmptyConfigurationMessage';

interface Props {
  onCreateTemplate: VoidFunction;
}

export const StagesCreateFallBack = ({ onCreateTemplate }: Props) => (
  <Stack gap="0.5rem">
    <EmptyConfigurationMessage />

    <Box>
      <Button onClick={onCreateTemplate}>create template</Button>
    </Box>
  </Stack>
);
